import { render, staticRenderFns } from "./index.vue?vue&type=template&id=747abc0c&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./index.vue?vue&type=style&index=0&id=747abc0c&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "747abc0c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/drone/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('747abc0c')) {
      api.createRecord('747abc0c', component.options)
    } else {
      api.reload('747abc0c', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=747abc0c&scoped=true", function () {
      api.rerender('747abc0c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/BusiCard/index.vue"
export default component.exports